import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Canonical tokens + self-hosted fonts load before the app's own styles.
import '@bymyword/tokens/tokens.css';
import '@bymyword/tokens/fonts.css';
import './index.css';
import { initSentry } from './lib/sentry';
import App from './App';

// No-op when VITE_SENTRY_DSN is absent; Replay/PII off; the bearer token scrubbed (see sentry.ts).
initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
